import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function AddUserNote() {
  const navigate = useNavigate();
  const users = ['Ryan Loeding', 'Veronica Barragan', 'Jim Hunt', 'Ted Araya', 'Timothy Rehrmann', 'Chuck Kaye', 'William Kline', 'Shauna Gliss', 'Paul Boyle', 'Zachary Gunnell', 'Nicolas Kraus', 'Lorraine MacGregor'];
  return <div className="space-y-4" data-id="element-280">
      <div className="flex items-center justify-between" data-id="element-281">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-282">Add User Note</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/users')} data-id="element-283">
          ← Back to Users
        </Button>
      </div>

      <Card data-id="element-284">
        <CardContent className="pt-6" data-id="element-285">
          <form className="space-y-4 max-w-sm" data-id="element-286">
            <div data-id="element-287">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-288">
                User
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[180px]" data-id="element-289">
                {users.map(u => <option key={u} data-id="element-290">{u}</option>)}
              </select>
            </div>
            <div data-id="element-291">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-292">
                Notes
              </label>
              <textarea className="w-full min-h-[100px] rounded border border-slate-300 bg-white p-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 resize-y" data-id="element-293" />
            </div>
            <div className="pt-1" data-id="element-294">
              <Button type="submit" data-id="element-295">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}